import { put, takeLatest } from 'redux-saga/effects';
import userActionTypes from '../types';
import { downloadUserDocFail } from '../actions';
import httpClient from '../../../utils/http-client';
import { handleError } from '../../../utils/utils';
import { Notify } from '@flexisaf/flexibull2';

export function* downloadUserDocument({ payload }) {
  const { data, document_name } = payload;
  try {
    const response = yield httpClient.post('/documents/download', data, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${document_name}`);
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    yield put(downloadUserDocFail(error?.message));
    const err = handleError(error);
  }
}

export function* onDownloadUserDocStart() {
  yield takeLatest(userActionTypes.DOWNLOAD_USER_DOCS_START, downloadUserDocument);
}
